import React, { ReactNode, memo } from 'react';

import { PortalHost, PortalProvider, Portal } from '@gorhom/portal';
import { PortalProviderProps } from '@gorhom/portal/lib/typescript/components/portalProvider/types';
import { PortalHostProps } from '@gorhom/portal/lib/typescript/components/portalHost/types';

interface MB_PortalProps {
    /**
     * Portal's key or name to be used as an identifier.
     * @type string
     * @default nanoid generated unique key.
     */
    name?: string;
    /**
     * Host's name to teleport the portal content to.
     * @type string
     * @default 'root'
     */
    hostName?: string;
    /**
     * Override internal mounting functionality, this is useful
     * if you want to trigger any action before mounting the portal content.
     * @type (mount?: () => void) => void
     * @default undefined
     */
    handleOnMount?: (mount: () => void) => void;
    /**
     * Override internal un-mounting functionality, this is useful
     * if you want to trigger any action before un-mounting the portal content.
     * @type (unmount?: () => void) => void
     * @default undefined
     */
    handleOnUnmount?: (unmount: () => void) => void;
    /**
     * Override internal updating functionality, this is useful
     * if you want to trigger any action before updating the portal content.
     * @type (update?: () => void) => void
     * @default undefined
     */
    handleOnUpdate?: (update: () => void) => void;
    /**
     * Portal's content.
     * @type ReactNode
     * @default undefined
     */
    children?: ReactNode | ReactNode[];
}


const MB_PortalProvider = memo((props: PortalProviderProps | { children?: ReactNode | ReactNode[] }) => {
    return <PortalProvider {...props} children={props.children ?? null} />;
});

const MB_PortalHost = memo((props: PortalHostProps) => {
    return <PortalHost {...props} />;
});

const MB_Portal = memo((props: MB_PortalProps) => {
    return <Portal {...props} />
});

export { MB_PortalProvider, MB_PortalHost, MB_Portal };
export type { MB_PortalProps };

